module.exports = __webpack_public_path__ + "Roboto-Bold.d329cc8b34667f114a95.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/fonts/roboto/Roboto-Bold.ttf
// module id = 381
// module chunks = 2